import type {
	FlashcardSetPopulated,
	GistPopulated,
	QuizPopulated,
} from "@vita-learning/types";
import { capitalize } from "~/shared/utils";

type Source =
	| QuizPopulated["source"]
	| FlashcardSetPopulated["source"]
	| GistPopulated["source"];

export const formatSourceOutput = <T extends Source>(source: T) =>
	source.toLowerCase().startsWith("u")
		? source.toUpperCase()
		: capitalize(source);
